import { AfterViewInit, Component, Input } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { AccessControl } from 'rev-shared/media/MediaConstants';
import { EmbedSize } from 'rev-shared/media/shareEmbed/EmbedSize';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

import styles from './video-share-container.module.less';

@Component({
	selector: 'video-share-container',
	templateUrl: './VideoShareContainer.Component.html'
})
export class VideoShareContainerComponent implements AfterViewInit {
	@Input() public mediaFeatures: any;
	@Input() public playbackPosition: number;
	@Input() public video: any;

	public readonly styles = styles;

	public embedDefaultSizeName: string = 'medium';
	public embedPresetSizes: EmbedSize[];
	public currentShareView: string = 'Link';

	constructor(
		private UserContext: UserContextService,
		private TranslateService: TranslateService
	) { }

	public ngAfterViewInit(): void {
		this.embedPresetSizes = this.getEmbedPresetSizes();
	}

	private getEmbedPresetSizes(): EmbedSize[] {
		return [
			new EmbedSize(560, 315, 'small', this.TranslateService.instant('Media_Videos_Embed_Small')),
			new EmbedSize(640, 360, 'medium', this.TranslateService.instant('Media_Videos_Embed_Medium')),
			new EmbedSize(853, 480, 'large', this.TranslateService.instant('Media_Videos_Embed_Large'))
		];
	}

	public get videoHasPublicAccess(): boolean {
		return this.video.accessControl === AccessControl.Public
			&& this.mediaFeatures.enablePublicVideoAccess;
	}

	public get videoHasEmbedAccessEnabled(): boolean {
		return this.video.isEmbedAccessEnabled;
	}

	public get sparkEnabled(): boolean {
		return this.mediaFeatures
			&& this.mediaFeatures.enableSpark
			&& this.UserContext.isUserAuthenticated();
	}
}
